import { useRefDep } from '@libs/client'
import { countItems, fbpTrackSingle } from '@ui/helpers'
import { useSetting } from './useSetting'

export enum PixelEvent {
  ViewContent = 'ViewContent',
  AddToCart = 'AddToCart',
  InitiateCheckout = 'InitiateCheckout',
  AddPaymentInfo = 'AddPaymentInfo',
  Purchase = 'Purchase'
}

const setLoggedEvent = new Set<PixelEvent>()

export const useFbp = () => {
  const [sellpageSetting] = useSetting('sellpage')
  const contentIdRef = useRefDep(sellpageSetting?.settings?.analytics?.content_id ?? '')
  const pixelIdsRef = useRefDep(sellpageSetting?.settings?.analytics?.pixel_ids ?? [])

  const fbpTrackViewContent = (price = 0) => {
    if (!setLoggedEvent.has(PixelEvent.ViewContent)) {
      fbpTrackSingle(
        PixelEvent.ViewContent,
        {
          content_ids: [contentIdRef.current],
          value: price || 0
        },
        pixelIdsRef.current
      )
      setLoggedEvent.add(PixelEvent.ViewContent)
    }
  }

  const fbpTrackAddToCart = (price = 0, quantity = 0) => {
    fbpTrackSingle(
      'AddToCart',
      {
        content_ids: [contentIdRef.current],
        num_items: quantity,
        value: quantity * price
      },
      pixelIdsRef.current
    )
  }

  const fbpTrackInitiateCheckout = (items: SfTypes.Item[] = [], items_amount = 0) => {
    fbpTrackSingle(
      'InitiateCheckout',
      {
        content_ids: [contentIdRef.current],
        num_items: countItems(items),
        value: items_amount
      },
      pixelIdsRef.current
    )
  }

  const fbpTrackAddPaymentInfo = (items: SfTypes.Item[] = [], items_amount = 0) => {
    fbpTrackSingle(
      'AddPaymentInfo',
      {
        content_ids: [contentIdRef.current],
        num_items: countItems(items),
        value: items_amount
      },
      pixelIdsRef.current
    )
  }

  const fbpTrackPurchase = (items: SfTypes.Item[] = [], amount = 0) => {
    fbpTrackSingle(
      'Purchase',
      {
        content_ids: [contentIdRef.current],
        num_items: countItems(items),
        value: amount
      },
      pixelIdsRef.current
    )
  }

  return {
    fbpTrackViewContent,
    fbpTrackAddToCart,
    fbpTrackInitiateCheckout,
    fbpTrackAddPaymentInfo,
    fbpTrackPurchase
  }
}
